import { InfoOutlined } from '@mui/icons-material';
import { Stack, TextField, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import React from 'react';

export interface DateOffsetRowProps {
  label: string;
  prefix: string;
  tooltip: string;
  value: number | null;
  onChange: (v: number | null) => void;
}

export default function DateOffsetRow({ label, prefix, tooltip, value, onChange }: DateOffsetRowProps) {
  const absValue = value !== null ? Math.abs(value) : '';
  const direction: 'before' | 'after' = (value ?? 0) < 0 ? 'before' : 'after';

  return (
    <Stack spacing={0.5} sx={{ '&.MuiStack-root': { mt: 1 } }}>
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Typography variant="body2">{label}</Typography>
        <Tooltip title={tooltip}>
          <InfoOutlined fontSize="small" color="action" />
        </Tooltip>
      </Stack>
      <Stack direction="row" alignItems="center" spacing={1} flexWrap="wrap" useFlexGap>
        <Typography variant="body2" color="text.secondary">
          {prefix}
        </Typography>
        <TextField
          type="number"
          size="small"
          sx={{ width: 60 }}
          slotProps={{ htmlInput: { min: 0 }, input: { sx: { height: 30, p: 0 } } }}
          value={absValue}
          onChange={(e) => {
            const raw = e.target.value ? Number(e.target.value) : null;
            onChange(raw !== null ? (direction === 'before' ? -raw : raw) : null);
          }}
        />
        <Typography variant="body2" color="text.secondary">
          days
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          color="primary"
          value={direction}
          disabled={!value}
          onChange={(_, direction) => {
            if (!direction || !value) return;
            onChange(direction === 'before' ? -Math.abs(value) : Math.abs(value));
          }}
        >
          <ToggleButton value="before" sx={{ py: 0.5 }}>
            before
          </ToggleButton>
          <ToggleButton value="after" sx={{ py: 0.5 }}>
            after
          </ToggleButton>
        </ToggleButtonGroup>
        <Typography variant="body2" color="text.secondary">
          the event
        </Typography>
      </Stack>
    </Stack>
  );
}
